module.exports = __webpack_public_path__ + "img/c05_unittechpriest_upgrade1_Normal_ua.6091f534.webp";